<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-wifi', fontSet: 'fad'}"
	[headerText]="(T.CONNECT_WIFI_DIALOG_CONNECT_TO | translate) + data.wifiNetwork.name"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<div class="wifi-connect-dialog-content">
			<mat-form-field class="white">
				<mat-label>{{ T.CONNECT_WIFI_DIALOG_PASSWORD_LABEL | translate }}</mat-label>
				<input
					#passwordInput="ngModel"
					[(ngModel)]="password"
					[required]="data.wifiNetwork.isSecure"
					matInput
					name="password"
					type="password"
				/>
				@if (passwordInput.invalid) {
					<mat-error>
						@if (passwordInput.errors.required) {
							{{ T.CONNECT_WIFI_DIALOG_PASSWORD_REQUIRED | translate }}
						}
					</mat-error>
				}
			</mat-form-field>

			<mat-form-field class="white">
				<mat-label>{{ T.CONNECT_WIFI_DIALOG_USERNAME | translate }}</mat-label>
				<input [(ngModel)]="username" matInput name="username" type="text" />
			</mat-form-field>

			<mat-form-field class="white">
				<mat-label>{{ T.CONNECT_WIFI_DIALOG_DOMAIN | translate }}</mat-label>
				<input [(ngModel)]="domain" matInput name="domain" type="text" />
			</mat-form-field>
		</div>
	</ng-container>

	<ng-container actions>
		<sim-button
			(onClick)="close()"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-times'}"
			[label]="T.BUTTON_CANCEL | translate"
			color="warn"
		/>

		<sim-button
			(onClick)="connect()"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.CONNECT_WIFI_DIALOG_CONNECT | translate"
			color="primary"
		/>
	</ng-container>
</sim-basic-material-dialog>
